import * as React from 'react';

const SvgIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25">
    <path
      id="Vector"
      fill="#0866FF"
      d="M24.146 12.571c0-6.67-5.404-12.073-12.073-12.073S0 5.902 0 12.571c0 6.026 4.415 11.02 10.187 11.927v-8.437H7.12v-3.49h3.067v-2.66c0-3.025 1.8-4.697 4.56-4.697 1.32 0 2.702.236 2.702.236v2.97h-1.522c-1.5 0-1.968.93-1.968 1.885v2.266h3.349l-.536 3.49H13.96v8.437c5.772-.906 10.187-5.901 10.187-11.927"
    ></path>
  </svg>
);

export default SvgIcon;
